import type { ColumnDef } from '@tanstack/react-table'
import { ArrowUpDown } from 'lucide-react'
import type { RiskProfileSummaryRow } from '../utils/riskProfileSummary.utils'

const formatCurrency = (value: number | null): string =>
  value === null ? '–' : `$${value.toLocaleString('en-NZ', { maximumFractionDigits: 0 })}`

const formatPercent = (value: number | null): string =>
  value === null ? '–' : `${(value * 100).toLocaleString('en-NZ', { maximumFractionDigits: 1 })}%`

const sortableHeader = (label: string) => {
  const Header: ColumnDef<RiskProfileSummaryRow>['header'] = ({ column }) => (
    <button
      type="button"
      className="inline-flex items-center gap-1.5"
      onClick={column.getToggleSortingHandler()}
    >
      {label}
      <ArrowUpDown className="size-3.5 text-muted-foreground" />
    </button>
  )
  return Header
}

export function getRiskProfileSummaryColumns(
  labelHeader: string,
): ColumnDef<RiskProfileSummaryRow>[] {
  return [
    {
      accessorKey: 'label',
      header: sortableHeader(labelHeader),
    },
    {
      accessorKey: 'damageCost',
      header: sortableHeader('Damage cost ($)'),
      cell: ({ row }) => formatCurrency(row.original.damageCost),
    },
    {
      accessorKey: 'damageCostPc',
      header: sortableHeader('Damage cost (%)'),
      cell: ({ row }) => formatPercent(row.original.damageCostPc),
    },
    {
      accessorKey: 'totalValue',
      header: sortableHeader('Total value ($)'),
      cell: ({ row }) => formatCurrency(row.original.totalValue),
    },
    {
      accessorKey: 'damageSeverityPc',
      header: sortableHeader('Damage severity (%)'),
      cell: ({ row }) => formatPercent(row.original.damageSeverityPc),
    },
    {
      accessorKey: 'quantityExposedPc',
      header: sortableHeader('Quantity exposed (%)'),
      cell: ({ row }) => formatPercent(row.original.quantityExposedPc),
    },
  ]
}
